<div class="modal-backdrop"></div>

<div class="modal-container">
  <div class="modal">
    <div class="modal-header">
      <h3 class="modal-title">Documentos disponíveis</h3>
    </div>

    <mat-dialog-content class="modal-body">
      @if(loading) {
        <mat-spinner class="spinner-container" diameter="48"></mat-spinner>
      }
      

      <!-- Error State -->
      @else if (error) {
        <div class="error-container">
          <mat-icon color="warn">error</mat-icon>
          <p>Erro ao carregar a lista de documentos. Por favor, tente novamente mais tarde.</p>
        </div>
      }

      <!-- Content State -->
      @else {
        <!-- Empty State -->
        @if (attachments.length === 0) {
          <div class="empty-list">
            <mat-icon class="empty-icon">folder_open</mat-icon>
            <p>Nenhum documento encontrado.</p>
          </div>
        }
        
        <!-- Documents List -->
        @else {
          <mat-list role="list">
            @for (attachment of attachments; track attachment.fileName) {
              <mat-list-item 
                class="document-item" 
                (click)="download(attachment.fileName)"
                (keydown.enter)="download(attachment.fileName)"
                (keydown.space)="download(attachment.fileName)"
                tabindex="0"
                role="button"
                [attr.aria-label]="'Baixar documento ' + attachment.fileName">
                
                <mat-icon mat-list-icon>description</mat-icon>
                
                <div mat-line class="document-name">{{ attachment.fileName }}</div>
                <div mat-line class="document-meta">
                  <small>
                    {{ attachment.fileType }} • 
                    {{ attachment.fileSize | number:'1.0-0' }} KB • 
                    {{ attachment.uploadDate | date:'dd/MM/yyyy HH:mm' }}
                  </small>
                </div>
                
                <button 
                  mat-icon-button 
                  class="download-button"
                  [attr.aria-label]="'Baixar ' + attachment.fileName"
                  (click)="$event.stopPropagation(); download(attachment.fileName)">
                  <mat-icon>download</mat-icon>
                </button>
              </mat-list-item>
            }
          </mat-list>
        }
      }
    </mat-dialog-content>

    <mat-dialog-actions class="modal-footer" align="end">
      <button class="btn btn-ghost" (click)="close()" type="button">Fechar</button>
    </mat-dialog-actions>
  </div>
</div>